import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import EntryScreen from './EntryScreen';

// Guardián de las rutas de la app. Antes NO existía: las rutas estaban abiertas
// y cada pantalla hacía su propio `useEffect` de "si no hay sesión, a /login".
// Eso dejaba dos cosas mal:
//
//   1. `clients-directory-screen` no tenía ese efecto, así que se podía abrir
//      sin sesión (los datos igual los protegía la RLS de vlsdb, pero la
//      pantalla se dibujaba).
//   2. NO se miraba el rol. Cualquiera con cuenta del hub entraba a Visitas,
//      tuviera o no membresía de `visitas`.
//
// Ahora los dos chequeos viven acá, una sola vez. Los `useEffect` de las
// pantallas quedan redundantes pero inofensivos (con el guardián puesto no
// llegan a dispararse); sacarlos es limpieza aparte, no hacía falta meterla en
// este cambio.
//
// Se verificó antes de poner el gate quién quedaba afuera: de las 29 cuentas
// activas, 6 tienen membresía de `visitas`, y las ÚNICAS 3 personas que alguna
// vez crearon una visita (Yaudanny 486, Elvira 40, Isaac 1) la tienen. O sea que
// no deja afuera a nadie que use la app.
//
// EntryScreen.jsx es copia de shared/vls-ui/ y NO se edita acá: se cambia en
// shared/ y se reparte con scripts/sync-ui.sh.
const MODULO = 'Visitas de Mercadeo';

export default function RequireAcceso({ children }) {
  const {
    isAuthenticated, userRole, loading, profileLoading,
    rolError, reintentarRol, signOut, user,
  } = useAuth();

  if (loading || profileLoading) return <EntryScreen modulo={MODULO} estado="cargando" />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // Antes que la rama de sin acceso: si la consulta de la membresía falló y
  // agotó su reintento, no sabemos si tiene permiso, y decirle que no lo tiene
  // sería un veredicto falso.
  if (rolError) {
    return (
      <EntryScreen modulo={MODULO} estado="error" onReintentar={reintentarRol} onSignOut={signOut} />
    );
  }
  if (!userRole) {
    return (
      <EntryScreen modulo={MODULO} estado="sin-acceso" correo={user?.email} onSignOut={signOut} />
    );
  }
  return children;
}
